import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Login';
import WarehouseList from './WarehouseList';
import Inventory from './Inventory';
import PrivateRoute from './PrivateRoute';
import Layout from './Layout';
import CustomerMovements from './CustomerMovements';

function App() {
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem('userData')) || null
  );


  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Login setUserData={setUserData} />
            </Layout>
          }
        />
        <Route
          path="/warehouses"
          element={
            <PrivateRoute element={<Layout><WarehouseList userData={userData} /></Layout>} />
          }
        />
        <Route
          path="/inventory/:warehouseId"
          element={
            <PrivateRoute element={<Layout><Inventory /></Layout>} />
          }
        />
        <Route
          path="/customer-movements"
          element={
            <PrivateRoute element={<Layout><CustomerMovements userData={userData} /></Layout>} />
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
